import ListingCardSkeleton from "@/src/shared/components/listing/skeletons/ListingCardSkeleton";

interface ICarouselSkeletonProps {
  title?: string;
  showTitle?: boolean;
  cardCount?: number;
}

const CarouselSkeleton: React.FC<ICarouselSkeletonProps> = ({
  title,
  showTitle = true,
  cardCount = 6,
}) => {
  return (
    <div className="w-full mb-8">
      {/* Title skeleton */}
      {showTitle && (
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            {title ? (
              <h2 className="text-xl font-semibold text-ink-black">{title}</h2>
            ) : (
              <div className="h-6 bg-gray-200 rounded-md w-48 animate-pulse" />
            )}
            <div className="h-4 w-4 bg-gray-200 rounded animate-pulse" />
          </div>

          {/* Navigation arrows skeleton */}
          <div className="flex space-x-2">
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
          </div>
        </div>
      )}

      {/* Cards container */}
      <div className="flex space-x-4 overflow-hidden">
        {Array.from({ length: cardCount }, (_, index) => (
          <div key={index} className="w-64 flex-shrink-0">
            <ListingCardSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarouselSkeleton;
